import React, { useEffect, useRef, useState } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import PageLayout from "../../PageLayout";
import AddNewDesign from "../DesignJobs/TaskHeader";
import DesignHeader from "../DesignJobs/DesignHeader";
import UploadBriefingDocuments from "../DesignJobs/UploadBriefingDocuments";
import UBDFooterButtons from "../DesignJobs/UBDFooterButtons";
import { submitUploadBrefingDocs } from "../../../store/actions/UploadBrefingDocsAction";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import plusCollapseImg from "../../../assets/images/plusCollapse.svg";
import editName from "../../../assets/images/editName.svg";
import TickUBD from "../../../assets/images/TickUBD.svg";
import CrossUBD from "../../../assets/images/CrossUBD.svg";
import { AddNavigation, validateUBDSpecialChar } from "../../../utils";
import { textFieldMaxLength, spcialCharAlert } from "../../../constants/index";

import { getTaskDetails } from "../../../store/actions/taskDetailAction";
import "../DesignJobs/index.scss";
import "./index.scss";
import { cloneDeep } from "lodash";
import { uploadtoAzureStrContainer } from "../../../apis/uploadAzuerContainer";
import { cancelTask } from "../../../apis/projectPlanApi";
import { Dialog } from "primereact/dialog";
import useAzureUploadFolderStructure from "../../../hooks/useAzureUploadFolderStructure";
import { totalFileSizeQuotient } from "../../../constants/FileUploadConstant";
import { CharacterLimit } from "../../common/CharacterLimit/CharacterLimit.js";
import { AzureContainerFail, AzureContainerSuccess } from "../../../Utils/constants.js";
import { SpecialProjectAction } from "../../../store/actions/ProjectSetupActions.js";
import { redirectUnallocatedLinksToArtworkStatus } from "../../../utils";
import {
  useUnsavedChangesWarning,
  UnsavedChangesDialog,
} from "../../common/NavigationPrompt/index.js";

import UnAuthorizedComponent from "../../UnAuthorized/UnAuthorizedComponent.js";
import { getReadWriteAccessForTask, getUserAccessForTask } from "../../../Utils/helpers.js";
import { ToastSuccessMsg } from "../../../Utils/constants.js";
import { Toast } from "primereact/toast";
import DsbpCommonPopup from "../../DSBP/DsbpCommonPopup";

const graphicAdaptionBrief = "Graphic Adaptation Brief *";
const otherReferenceDocs = "Other Reference Documents & Assets";

function UBD() {
  const toast = useRef(null);
  const [data, setData] = useState(null);
  const [fileNotFound, setFileNotFound] = useState(false);
  const [gABriefAdaptationForUI, setGABriefAdaptationForUI] = useState([]);
  const [initialGABriefAdaptationForUI, setInitialGABriefAdaptationForUI] = useState([]);
  const [otherRefernceDocsForUI, setOtherRefernceDocsForUI] = useState([]);
  const [initialOtherRefernceDocsForUI, setInitialOtherRefernceDocsForUI] = useState([]);
  const [submitBtnState, setSubmitBtnState] = useState(false);
  const [updated, setUpdated] = useState(false);
  const [projectData, setProjectData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [formValid, setFormValid] = useState(false);
  const [inputValid, setInputValid] = useState({});
  const [GABriefSeq, setGABriefSeq] = useState(1);
  const [otherDocSeq, setOtherDocSeq] = useState(1);
  const [errorAlert, setErrorAlert] = useState(false);
  const { TaskDetailsData, loading } = useSelector((state) => state.TaskDetailsReducer);

  const GABriefListData =
    (TaskDetailsData?.ArtworkAgilityTasks?.[0]?.GABriefList &&
      TaskDetailsData?.ArtworkAgilityTasks?.[0]?.GABriefList?.[0]) ||
    [];
  const OtherReferenceDocData =
    (TaskDetailsData?.ArtworkAgilityTasks?.[0]?.OtherReferenceDoc &&
      TaskDetailsData?.ArtworkAgilityTasks?.[0]?.OtherReferenceDoc?.[0]) ||
    [];
  
  const DefaultGAName = Object.keys(GABriefListData)?.length && GABriefListData?.GroupName;
  const [graphicData, setGraphicData] = useState(DefaultGAName);
  const [graphicDataNew, setGraphicDataNew] = useState();
  const [groupnameUpdated, setGroupnameUpdated] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const graphicInputRef = useRef(null);
  let { page1, page2, pageType, TaskID, ProjectID } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { allProjects } = useSelector((state) => state.myProject);
  const location = useLocation();
  const currentUrl = location.pathname;
  const id = `${TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Task_Key}`;
  const headerName = `${TaskDetailsData?.ArtworkAgilityTasks?.[0]?.TaskPlaceholderName}`;
  const shortName = TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Task_Type;
  const AzureSubFolder = "GA Brief";

  let breadcrumb = AddNavigation(headerName);

  const BU = TaskDetailsData?.ArtworkAgilityTasks?.[0]?.BU;
  const projectName = TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Project_Name;
  const taskStatus = TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Task_Status;
  const IsEnabledCancelTask = TaskDetailsData?.ArtworkAgilityTasks?.[0]?.IsEnabledCancelTask;
  
  const { markDirty, markClean } = useUnsavedChangesWarning();
  const [pageEdited, setPageEdited] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [actionType, setActionType] = useState("");
  const [selectDialog, setSelectDialog] = useState(false);

  const folderStructure = useAzureUploadFolderStructure("GA Brief", 0, false, graphicData);
  const {
    userDetails: { UserGroup },
  } = useSelector((state) => state?.UserDetailsReducer);
  const User = useSelector((state) => state.UserReducer);
  const userInformation = User.userInformation;
  const userAccessPayLoad = {
    ArtworkAgilityPage: {
      UserId: userInformation?.userid,
      ProjectID: ProjectID,
      UserGroup: UserGroup,
    },
  };
  const [accessSecurityMatrix, setUserAccess] = useState(false);
  const [checkReadWriteAccess, setCheckReadWriteAccess] = useState(false);
  const [FormData, setFormData] = useState({
    GraphicAdaptationBriefFile: [],
    OtherReferenceDocumentsAssetsFile: [],
    graphicData: DefaultGAName,
  });
  const [InitialFormData, setInitialFormData] = useState({
    GraphicAdaptationBriefFile: [],
    OtherReferenceDocumentsAssetsFile: [],
    graphicData: DefaultGAName,
  });


  useEffect(() => {
    setUserAccess(getUserAccessForTask(TaskDetailsData));
    setCheckReadWriteAccess(getReadWriteAccessForTask(TaskDetailsData));
  }, [TaskDetailsData?.AccessType]);

  const hideDialog = () => {
    setFileNotFound(false);
  };

  useEffect(() => {
    if (userInformation?.userid && UserGroup?.length) {
      setLoader(false);
      dispatch(getTaskDetails(TaskID, ProjectID, userAccessPayLoad));
    }
  }, [dispatch, TaskID, ProjectID, userInformation?.userid, UserGroup?.length]);

  useEffect(() => {
    let projectData = allProjects?.find((project) => project.Project_ID === ProjectID);
    setProjectData(projectData);
  }, [projectData]);

  const orderBySequence = (arr) => {
    return arr.sort(function (a, b) {
      return a.Sequence - b.Sequence;
    });
  };

  useEffect(() => {
    const isGaBriefDocUpdated = JSON.stringify(gABriefAdaptationForUI) === JSON.stringify(initialGABriefAdaptationForUI)
    const isOtherRefDocUpdated = JSON.stringify(otherRefernceDocsForUI) === JSON.stringify(initialOtherRefernceDocsForUI)

    if(!isOtherRefDocUpdated) {
      setSubmitBtnState(true)
      setFormValid(true)
    }
    if(!isGaBriefDocUpdated) {
      const checkMinFileAvailable = gABriefAdaptationForUI[0]?.File_Name !== ""
      setSubmitBtnState(checkMinFileAvailable)
      setFormValid(checkMinFileAvailable)
    }
    
  }, [gABriefAdaptationForUI, otherRefernceDocsForUI])

  useEffect(() => {
    if (gABriefAdaptationForUI.length === 0) {
      setFormValid(false);
      const temp = cloneDeep(gABriefAdaptationForUI);
      temp.push({
        Design_Job_ID: temp.length + 1,
        isNew: true,
        Additional_Info: "Test",
        Select: false,
        File_Name: "",
        Sequence: GABriefSeq,
        Version: 1,
      });
      setGABriefAdaptationForUI(orderBySequence(temp));
    }
    if (otherRefernceDocsForUI.length === 0) {
      const temp = cloneDeep(otherRefernceDocsForUI);
      temp.push({
        Design_Job_ID: temp.length + 1,
        isNew: true,
        Additional_Info: "Test",
        Select: false,
        File_Name: "",
        Sequence: otherDocSeq,
        Version: 1,
      });
      setOtherRefernceDocsForUI(orderBySequence(temp));
    }
  }, [gABriefAdaptationForUI, otherRefernceDocsForUI]);

  useEffect(() => {
    if (TaskDetailsData) {
      const graphicABData = [],
        otherRDData = [];
        Object.keys(GABriefListData)?.length && GABriefListData?.FileList?.map((item) => {
        graphicABData.push(item);
      });
      Object.keys(OtherReferenceDocData)?.length && OtherReferenceDocData?.FileList?.map((item) => {
        otherRDData.push(item);
      });
      setGABriefAdaptationForUI(orderBySequence(graphicABData) || []);
      setInitialGABriefAdaptationForUI(orderBySequence(graphicABData) || []);
      setOtherRefernceDocsForUI(orderBySequence(otherRDData) || []);
      setInitialOtherRefernceDocsForUI(orderBySequence(otherRDData) || []);
      setData(TaskDetailsData?.ArtworkAgilityTasks?.[0] || []);

      const specialProjectFlag = TaskDetailsData?.SpecialProject;
      dispatch(SpecialProjectAction(specialProjectFlag));
      redirectUnallocatedLinksToArtworkStatus(currentUrl, specialProjectFlag, navigate);
    }
  }, [TaskDetailsData]);

  const handleCancelClick = () => {
    if (pageEdited) {
      setActionType("Cancel");
      setShowDialog(true);
    } else {
      handleCancel();
    }
  };

  const onHandleCancelClick = async () => {
    setSelectDialog(false);
    
    const response = await cancelTask(TaskID, ProjectID);
    
    if (response?.data) {
      const response_code = response?.data?.Status?.Code;
      if( response_code == 0)
      {  
        if (toast.current) { 
          toast.current.show({
            severity: "success",
            detail: "Task cancelled successfully.",
            life: 3000,
          });

          setTimeout(() => {
            if (page2 && page2 === "projectPlan") {
              navigate(`/${page1}/${page2}/${ProjectID}`)
            } else if (pageType) {
              navigate(`/${pageType}`);
            }

          }, 5000);
        }
      }else{
        if (toast.current) {
          toast.current.show({
          severity: "error",
          detail: response?.data?.Status?.Message || "Failed to cancel task.",
          life: 3000,
        });
      }
      }
    }  
    else { 
      if (toast.current) {
        toast.current.show({
          severity: "error",
          detail: "Failed to cancel task.",
          life: 3000,
        });
      }
    }  
  }

  const handleCancel = () => {
    if (page2 && page2 === "projectPlan") {
      return navigate(`/${page1}/${page2}/${TaskDetailsData?.ArtworkAgilityPage?.AWM_Project_ID}`);
    } else if (pageType) {
      return navigate(`/${pageType}`);
    }
  };

  const handleEditClick = () => {
    setIsEditMode(!isEditMode);
  };

  const handleCancelButton = () => {
    setGraphicData(graphicDataNew ? graphicDataNew : DefaultGAName);
    setIsEditMode(!isEditMode);
  };

  const confirmNavigation = () => {
    if (actionType === "Cancel") {
      handleCancel();
      markClean();
    } else if (actionType === "EditIcon") {
      setIsEditMode(!isEditMode);
    }
    setShowDialog(false);
  };

  const cancelNavigation = () => {
    setShowDialog(false);
  };

  const onFileUpload = (e, FileDetails, fileUploadSection, seq) => {
    if (fileUploadSection === graphicAdaptionBrief) {
      const temp = cloneDeep(gABriefAdaptationForUI);
      temp.forEach((obj, i) => {
        if (seq === obj?.Sequence) {
          obj["File_Name"] = e?.files?.[0]?.name;
          if (e?.files?.[0]?.name !== "") {
            obj["Info"] = {
              fileInfo: e?.files?.[0],
              uploadType: "",
              sequence: seq,
              version: FileDetails?.Version,
              id: i,
              Full_Name:
                FileDetails?.Info === undefined
                  ? FileDetails?.Full_Name
                  : FileDetails?.Info.Full_Name,
              Email: FileDetails?.Info === undefined ? FileDetails?.Email : FileDetails?.Info.Email,
            };
            obj["AzureFile"] =
              FileDetails?.file !== undefined ? FileDetails?.file : FileDetails?.AzureFile;
            obj["Timestamp"] = FileDetails?.Timestamp;
            setFormValid(true);
          } else {
            obj["Info"] = "";
            obj["AzureFile"] = "";
          }
          setGABriefAdaptationForUI(orderBySequence(temp));
        }
      });

      setFormData((prev) => {
        return {
          ...prev,
          GraphicAdaptationBriefFile: temp,
        };
      });
    }
    if (fileUploadSection === otherReferenceDocs) {
      const temp = cloneDeep(otherRefernceDocsForUI);
      temp.forEach((obj, i) => {
        if (seq === obj?.Sequence) {
          obj["File_Name"] = e?.files?.[0]?.name;
          if (e?.files?.[0]?.name !== "") {
            obj["Info"] = {
              fileInfo: e?.files?.[0],
              uploadType: "",
              sequence: seq,
              version: FileDetails?.Version,
              id: i,
              Full_Name:
                FileDetails?.Info === undefined
                  ? FileDetails?.Full_Name
                  : FileDetails?.Info.Full_Name,
              Email: FileDetails?.Info === undefined ? FileDetails?.Email : FileDetails?.Info.Email,
            };
            obj["AzureFile"] =
              FileDetails?.file !== undefined ? FileDetails?.file : FileDetails?.AzureFile;
            obj["Timestamp"] = FileDetails?.Timestamp;

            // Set formValid true only if gABriefAdaptationForUI has files uploaded previously
            const hasGABriefPreviousFiles = gABriefAdaptationForUI?.some(
              (item) => item?.File_Name
            );
            if (hasGABriefPreviousFiles) {
              setFormValid(true);
            }
          } else {
            obj["Info"] = "";
            obj["AzureFile"] = "";
          }
          setOtherRefernceDocsForUI(orderBySequence(temp));
        }
      });
      setFormData((prev) => {
        return {
          ...prev,
          OtherReferenceDocumentsAssetsFile: temp,
        };
      });
    }
  };

  const onFileClear = (fileUploadSection, fileListToRemove) => {
    if (fileUploadSection === graphicAdaptionBrief) {
      const newFileList = gABriefAdaptationForUI.filter(
        (fileList) => fileList?.Sequence !== fileListToRemove?.Sequence
      );
      setGABriefAdaptationForUI(newFileList);
      newFileList.every((obj) => {
        if ("Info" in obj && "AzureFile" in obj) {
          setFormValid(true);
          return false;
        } else {
          setFormValid(false);
          return true;
        }
      });
      setFormData((prev) => {
        return {
          ...prev,
          GraphicAdaptationBriefFile: newFileList,
        };
      });
    }
    if (fileUploadSection === otherReferenceDocs) {
      const newFileList = otherRefernceDocsForUI.filter(
        (fileList) => fileList?.Sequence !== fileListToRemove?.Sequence
      );
      setOtherRefernceDocsForUI(newFileList);
      setFormData((prev) => {
        return {
          ...prev,
          OtherReferenceDocumentsAssetsFile: newFileList,
        };
      });
    }
  };

  const addNewEmptyDesign = () => {
    setGABriefSeq(GABriefSeq + 1);
    gABriefAdaptationForUI.push({
      Design_Job_ID: gABriefAdaptationForUI.length + 1,
      isNew: true,
      Additional_Info: "Test",
      Select: false,
      File_Name: "",
      Sequence: GABriefSeq + 1,
      Version: 1,
    });
    setGABriefAdaptationForUI(orderBySequence(gABriefAdaptationForUI));
    setUpdated(!updated);
    markDirty();
  };

  useEffect(() => {
    //set Flag to enable or disable submit button
    let flag = false;
    if (!groupnameUpdated) {
      gABriefAdaptationForUI.forEach((obj) => {
        if ((obj.File_Name && obj.isNew === true) || obj.UV_File_Name) {
          if (flag === false) flag = true;
        }
      });
      otherRefernceDocsForUI.forEach((obj) => {
        if ((obj.File_Name && obj.isNew === true) || obj.UV_File_Name) {
          if (
            flag === false &&
            gABriefAdaptationForUI.length &&
            gABriefAdaptationForUI?.[0].Version !== 0
          ) {
            flag = true;
          }
        }
      });
    } else if (groupnameUpdated) {
      if (gABriefAdaptationForUI.length && gABriefAdaptationForUI?.[0].Version !== 0) {
        flag = true;
      }
    } else {
      flag = false;
    }
  }, [gABriefAdaptationForUI, otherRefernceDocsForUI, groupnameUpdated]);

  useEffect(() => {
    setFormData((prev) => {
      return {
        ...prev,
        graphicData: graphicData,
      };
    });
  }, [graphicData]);

  useEffect(() => {
    const isObjectEqual = JSON.stringify(InitialFormData) === JSON.stringify(FormData);
    if (!isObjectEqual) {
      setPageEdited(true);
    } else {
      setPageEdited(false);
    }
  }, [FormData]);

  useEffect(() => {
    if (pageEdited) {
      markDirty();
    } else {
      markClean();
    }
  }, [pageEdited]);

  useEffect(() => {
    markClean();
    setPageEdited(false);
  }, []);

  const GABriefHeader = (
    <>
      <div
        style={{
          marginLeft: 20,
          padding: 5,
        }}
        className="ubd-accordion-header"
      >
        Graphic Adaptation Brief{" "}
        <sup>
          <b>*</b>
        </sup>
      </div>
      <div
        className="add-file-ubd"
        onClick={() => addNewEmptyDesign()}
        disabled={taskStatus === "Complete" || !checkReadWriteAccess}
      >
        <img
          src={plusCollapseImg}
          alt="filter logo"
          className="heade-plus-icon"
          disabled={taskStatus === "Complete" || !checkReadWriteAccess}
        />{" "}
        Add Files
      </div>
    </>
  );

  const otherRDAddNewEmptyDesign = () => {
    setOtherDocSeq(otherDocSeq + 1);
    otherRefernceDocsForUI.push({
      Design_Job_ID: otherRefernceDocsForUI.length + 1,
      isNew: true,
      Additional_Info: "Test",
      Select: false,
      File_Name: "",
      Sequence: otherDocSeq + 1,
      Version: 1,
    });
    setOtherRefernceDocsForUI(otherRefernceDocsForUI);
    setUpdated(!updated);
  };

  const ORDAssetsHeader = (
    <>
      <div
        style={{
          marginLeft: 20,
          padding: 5,
        }}
        className="ubd-accordion-header"
      >
        Other Reference Documents & Assets
      </div>
      <div
        className="add-file-ubd"
        onClick={() => otherRDAddNewEmptyDesign()}
        disabled={taskStatus === "Complete" || !checkReadWriteAccess}
      >
        <img
          src={plusCollapseImg}
          alt="filter logo"
          className="heade-plus-icon"
          disabled={taskStatus === "Complete" || !checkReadWriteAccess}
        />{" "}
        Add Files
      </div>
    </>
  );

  useEffect(() => {
    if (TaskDetailsData?.ArtworkAgilityTasks?.[0]?.GABriefList) {
      setGraphicData(DefaultGAName);
      setInitialFormData((prev) => {
        return {
          ...prev,
          graphicData: TaskDetailsData?.ArtworkAgilityTasks?.[0]?.GABriefList && DefaultGAName,
        };
      });
      setFormData((prev) => {
        return {
          ...prev,
          graphicData: TaskDetailsData?.ArtworkAgilityTasks?.[0]?.GABriefList && DefaultGAName,
        };
      });
    }
    
  }, [TaskDetailsData]);

  const updateData = () => {
    setIsEditMode(!isEditMode);
    if (graphicInputRef?.current?.value?.trim()?.length > 0) {
      setGraphicData(graphicInputRef.current.value);
      setGraphicDataNew(graphicInputRef.current.value);

      if (
        DefaultGAName !==
          graphicInputRef.current.value
      ) {
        setGroupnameUpdated(true);
      } else {
        setGroupnameUpdated(false);
      }
    } else {
      setGraphicData(DefaultGAName);
    }
    if (toast?.current) {
      toast.current.show({
        severity: "success",
        detail: ToastSuccessMsg,
        life: 3000,
      });
    } else {
      console.error("Toast reference is null");
    }
  };

  const getGABriefListObj = () => {
    let GABriefList = [];
    gABriefAdaptationForUI.map(async (obj) => {
      if (obj.Info) {
        const fileSize = Math.round(obj?.Info?.fileInfo?.size / totalFileSizeQuotient);
        const temp = {
          Version: obj.Info.version,
          Size: fileSize === 0 ? "1" : `${fileSize}`,
          Sequence: `${obj?.Sequence}`,
          Filename: obj.File_Name,
          Full_Name: obj?.Info?.Full_Name,
          Email: obj?.Info?.Email,
          TypeOfFile: obj?.File_Name?.split(".")?.pop(),
          JobID: "",
          JobName: "",
        };
        GABriefList.push(temp);
        let azureRes = await uploadtoAzureStrContainer(
          obj?.file === undefined ? obj.AzureFile : obj.file,
          `${folderStructure}/${obj.Info.version}/`
        );
        if (azureRes) {
          if (toast.current) {
            toast.current.show(AzureContainerSuccess);
          }
        } else {
          if (toast.current) {
            toast.current.show(AzureContainerFail);
          }
        }
      }
    });
    return GABriefList;
  };

  const getOtherReferenceDocObj = () => {
    let OtherReferenceDoc = [];
    otherRefernceDocsForUI.map(async (obj) => {
      if (obj.Info) {
        const fileSize = Math.round(obj?.Info?.fileInfo?.size / totalFileSizeQuotient);
        const temp = {
          Version: obj.Info.version,
          Size: fileSize === 0 ? "1" : `${fileSize}`,
          Sequence: `${obj.Info.sequence}`,
          Filename: obj.File_Name,
          Full_Name: obj?.Info?.Full_Name,
          Email: obj?.Info?.Email,
          TypeOfFile: obj?.File_Name?.split(".")?.pop(),
          JobID: "",
          JobName: "",
        };
        OtherReferenceDoc.push(temp);
        let azureRes = await uploadtoAzureStrContainer(
          obj?.file === undefined ? obj.AzureFile : obj.file,
          `${folderStructure}/${obj.Info.version}/`
        );
        if (azureRes) {
          if (toast.current) {
            toast.current.show(AzureContainerSuccess);
          }
        } else {
          if (toast.current) {
            toast.current.show(AzureContainerFail);
          }
        }
      }
    });
    return OtherReferenceDoc;
  };

  const onSubmit1 = async () => {
    setLoader(true);
    const submitObjGABriefList = getGABriefListObj();
    const submitObjOtherReferenceDoc = getOtherReferenceDocObj();
    let pageInstructions = [];
    submitObjGABriefList.forEach((obj) => {
      pageInstructions.push({
        instruction: "APPEND",
        target: "GABriefList",
        content: obj,
      });
    });
    submitObjOtherReferenceDoc.forEach((obj) => {
      pageInstructions.push({
        instruction: "APPEND",
        target: "OtherReferenceDoc",
        content: obj,
      });
    });

    const headers = {
      key: "If-Match",
      value: TaskDetailsData?.ArtworkAgilityPage?.Etag,
    };
    let formData = {
      caseTypeID: "PG-AAS-Work-UploadBriefingDocuments",
      content: {
        AWMTaskID: TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Task_ID,
        AWMProjectID: TaskDetailsData?.ArtworkAgilityPage?.AWM_Project_ID,
        GroupName: graphicData,
        Action: submitObjGABriefList.length
          ? "add"
          : gABriefAdaptationForUI.length && submitObjOtherReferenceDoc.length
          ? "add"
          : gABriefAdaptationForUI.length && groupnameUpdated
          ? "update"
          : "NA",
      },
      pageInstructions: pageInstructions,
    };

    await submitUploadBrefingDocs(formData, id, headers);
    setGroupnameUpdated(false);
    setPageEdited(false);
    setLoader(false);
    if (page2 && page2 === "projectPlan") {
      navigate(`/${page1}/${page2}/${TaskDetailsData?.ArtworkAgilityPage?.AWM_Project_ID}`);
    } else if (pageType) {
      navigate(`/${pageType}`);
    }
  };

  const onCancelTask = () => {
    setSelectDialog(true);  
    cancelTask()
  }

  const handleChange = (e) => {
    const value = e.target.value;
    const validInput = validateUBDSpecialChar(value);
    if (validInput) {
      setErrorAlert(false);
      setInputValid &&
        setInputValid((prevState) => ({
          ...prevState,
          [id]: true,
        }));
    } else {
      setInputValid &&
        setInputValid((prevState) => ({
          ...prevState,
          [id]: false,
        }));
      setErrorAlert(true);
    }
    setGraphicData(e.target.value);
  };

  return (
    <>
      <PageLayout>
        <Toast ref={toast} />
        {accessSecurityMatrix ? (
          <>
            {" "}
            <Dialog
              visible={fileNotFound}
              className="ubd-dialog"
              onHide={hideDialog}
              header={<div className="p-dialog-ubd">Message</div>}
            >
              File not found in Azure Storage.
            </Dialog>
            <DesignHeader
              setAddNewDesign={() => {}}
              onSelectAll={() => {}}
              breadcrumb={breadcrumb}
              headerName={headerName}
              label={shortName}
              lastLabel={"UBD"}
              pageEdited={pageEdited}
              setPageEdited={setPageEdited}
              closeFlag={false}
              actionButtonsFlag={true}
            />
            <div className="task-details">
              {
                <AddNewDesign
                  {...data}
                  actionButtonsFlag={true}
                  TaskDetailsData={TaskDetailsData}
                  Project_Name={projectName}
                  pageEdited={pageEdited}
                  setPageEdited={setPageEdited}
                />
              }

              <LoadingOverlay
                active={
                  loading ||
                  loader ||
                  gABriefAdaptationForUI === null ||
                  otherRefernceDocsForUI === null
                }
                spinner
                text=""
                className="overlay-loader"
              >
                <div>
                  <div
                    className="graphicAdaptionBrief"
                    disabled={taskStatus === "Complete" || !checkReadWriteAccess}
                  >
                    {isEditMode ? (
                      <div className="graphic-container">
                        <div className="graphic-item">
                          <input
                            type="text"
                            maxLength={textFieldMaxLength}
                            className="graphicInput"
                            onChange={(e) => handleChange(e)}
                            defaultValue={graphicData}
                            ref={graphicInputRef}
                            disabled={taskStatus === "Complete" || !checkReadWriteAccess}
                          />

                          <img
                            src={TickUBD}
                            alt="TickUBD logo"
                            onClick={() => updateData()}
                            disabled={taskStatus === "Complete" || !checkReadWriteAccess}
                          />
                          <img
                            src={CrossUBD}
                            alt="CrossUBD logo"
                            onClick={() => handleCancelButton()}
                            disabled={taskStatus === "Complete" || !checkReadWriteAccess}
                          />
                        </div>
                        <div>
                          <CharacterLimit field={graphicData} maxLength={textFieldMaxLength} />
                        </div>
                      </div>
                    ) : (
                      <div className="ga-brif-container">
                        <div className="ga-Brif">{graphicData}</div>
                        <img
                          src={editName}
                          alt="edit logo"
                          onClick={() => handleEditClick(!isEditMode)}
                          className="edit-Icon"
                          disabled={taskStatus === "Complete" || !checkReadWriteAccess}
                        />
                      </div>
                    )}
                    {errorAlert && <div class="special_char_alert">{spcialCharAlert}</div>}
                  </div>

                  {/* Graphic Adaptation Brief* */}
                  <div className="design-intent-header">{GABriefHeader}</div>

                  {gABriefAdaptationForUI &&
                    gABriefAdaptationForUI.length > 0 &&
                    gABriefAdaptationForUI.map((item) => {
                      if (item && item?.Action !== "delete") {
                        return (
                          <UploadBriefingDocuments
                            azureSubFolder={AzureSubFolder}
                            key={item.Design_Job_ID}
                            item={item}
                            pageEdited={pageEdited}
                            setPageEdited={setPageEdited}
                            checkReadWriteAccess={checkReadWriteAccess}
                            fileUploadSection={graphicAdaptionBrief}
                            disableDelete={
                              gABriefAdaptationForUI[0]?.File_Name === ""
                            }
                            taskStatus={taskStatus}
                            onFileUpload={onFileUpload}
                            onFileClear={onFileClear}
                            sequence={item.Sequence}
                          />
                        );
                      }
                    })}
                  {/* Other Reference Documents & Assets */}
                  <div className="design-intent-header">{ORDAssetsHeader}</div>
                  {otherRefernceDocsForUI &&
                    otherRefernceDocsForUI.length > 0 &&
                    otherRefernceDocsForUI.map((item) => {
                      if (item && item?.Action !== "delete") {
                        return (
                          <UploadBriefingDocuments
                            azureSubFolder={AzureSubFolder}
                            key={item.Design_Job_ID}
                            item={item}
                            checkReadWriteAccess={checkReadWriteAccess}
                            fileUploadSection={otherReferenceDocs}
                            pageEdited={pageEdited}
                            setPageEdited={setPageEdited}
                            disableDelete={
                              otherRefernceDocsForUI[0]?.File_Name === ""
                            }
                            taskStatus={taskStatus}
                            onFileUpload={onFileUpload}
                            onFileClear={onFileClear}
                            sequence={item.Sequence}
                          />
                        );
                      }
                    })}
                </div>
              </LoadingOverlay>
            </div>
            <UBDFooterButtons
              handleCancel={handleCancelClick}
              onSubmit={onSubmit1}
              pageEdited={pageEdited}
              setPageEdited={setPageEdited}
              checkReadWriteAccess={checkReadWriteAccess}
              formValid={(!submitBtnState && !formValid) || !formValid || !Object.values(inputValid).every((valid) => valid)}
              taskStatus={taskStatus}
              showCancelTaskButton={true}
              IsEnabledCancelTask= {IsEnabledCancelTask}
              onCancelTask={onCancelTask}
            />
            {/* UnsavedChangesDialog popup*/}
            <UnsavedChangesDialog
              visible={showDialog}
              onCancel={cancelNavigation}
              onConfirm={confirmNavigation}
            />
              {selectDialog && (
                <DsbpCommonPopup
                actionHeader={<p><p>Are you sure you want to cancel this task? </p><p>This action cannot be undone.</p></p>}
                dasbpDialog={selectDialog}
                setDasbpDialog={setSelectDialog}
                rejectFormData={[{}]}
                onSubmit={() =>
                  onHandleCancelClick()
                }
                okButtonShow={false}
                deleteButtonShow={false}
                yesButtonShow={false}
                submitButtonShow={true}
                disconnectButtonShow={true}
                showCancel={false}
                />
              )}
          </>
        ) : (
          <UnAuthorizedComponent nowrapper={true} />
        )}
      </PageLayout>
    </>
  );
}

export default UBD;